import React from "react";

interface CustomIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  size?: number;
  width?: number | string;
  height?: number | string;
  alt?: string;
}

const CustomIcon: React.FC<CustomIconProps> = ({
  src,
  size = 40,
  width,
  height,
  alt = "Icon",
  ...props
}) => {
  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: width || size, // Fallback auf `size`, wenn `width` nicht angegeben ist
        height: height || size, // Fallback auf `size`, wenn `height` nicht angegeben ist
        ...(props.style || {}), // zusätzliche Styles
      }}
      {...props} // Weitergabe anderer Attribute, z.B. `onClick`
    />
  );
};

export const BruchharschIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/bh.png"} alt="BruchharschIcon" />;
};

export const RottensnowIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/rs.png"} alt="RottensnowIcon" />;
};

export const IceIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/is.png"} alt="IceIcon" />;
};

export const PowderIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/po.png"} alt="PowderIcon" />;
};

export const FirnIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/fi.png"} alt="FirnIcon" />;
};

export const CrustIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/hd.png"} alt="CrustIcon" />;
};

export const SummersnowIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/ss.png"} alt="SummersnowIcon" />;
};

export const RecycledpowderIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/np.png"} alt="RecycledpowderIcon" />;
};

export const WindformedsnowIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/wb.png"} alt="WindformedsnowIcon" />;
};

export const ChangingsnowIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/wv.png"} alt="ChangingsnowIcon" />;
};

export const WetsnowIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/ws.png"} alt="WetsnowIcon" />;
};

export const NosnowIcon: React.FC = () => {
  return <CustomIcon src={"../../icons/ap.png"} alt="NosnowIcon" />;
};

interface SnowIconProps {
  snowType: keyof typeof snowIcons;
  size?: number;
  style?: React.CSSProperties;
}

export const snowIcons = {
  pulverschnee: PowderIcon,
  firn: FirnIcon,
  bruchharsch: BruchharschIcon,
  faulschnee: RottensnowIcon,
  vereist: IceIcon,
  harschdeckel: CrustIcon,
  sommerschnee: SummersnowIcon,
  noppenpulver: RecycledpowderIcon,
  windbeeinflusst: WindformedsnowIcon,
  wechselhafterschnee: ChangingsnowIcon,
  nassschnee: WetsnowIcon,
  aper: NosnowIcon,
};

class SnowIcon extends React.Component<SnowIconProps> {
  getSnowIcon(snowType: keyof typeof snowIcons) {
    const IconComponent = snowIcons[snowType];
    return IconComponent ? (
      <IconComponent size={this.props.size} style={this.props.style} />
    ) : (
      <></>
    );
  }

  render() {
    const { snowType } = this.props;
    return this.getSnowIcon(snowType);
  }
}

export default SnowIcon;
